// extracted by mini-css-extract-plugin
module.exports = {"root":"partners-module--root--2Idpj","cardWrapper":"partners-module--cardWrapper--walGN","brandWrapper":"partners-module--brandWrapper--C2oON"};